(function ($, undefined) {
    var cacheKey = 'grid';
    var defaultOptions = {
        'pagerElements': undefined,
        'pagerFirstSelector': '.pager-first',
        'pagerPreviousSelector': '.pager-prev',
        'pagerNextSelector': '.pager-next',
        'pagerLastSelector': '.pager-last',
        'pagerDisplaySelector': '.pager-display',
        'pagerPageNumbersSelector': 'ul',
        'pageSizeAttr': 'data-page-size',
        'rowSelectorAttr': 'data-row-selector',
        'rowSelector': '> tbody > tr',
        'pageSizes': [10, 25, 50],
        'pageSize': undefined,
        'enableCircularPaging': false,
        'pageCount': 0,
        'currentPage': 1,
        'sortable': true,
        'parsers': {},
        'defaultSortOrder': {},
        'sortAscClass': 'asc',
        'sortDescClass': 'desc',
        'pagingEnabled': true,
        'sortingEnabled': true,
        'showFirstSelector': true,
        'showLastSelector': true,
        maxNumOfPageNumbers: 6
    };

    var getOptions = function (grid) {
        var options = grid.data(cacheKey);
        return options;
    };

    var getRows = function ($grid, start, end, includeAttached, preventFilter) {
        var options = getOptions($grid);
        // TODO : Add check of rows have been updated...

        var rows = options.parentRows; //rows

        var filterPredicate = options.filterPredicate;

        if (filterPredicate) {
            var filteredRows = options.filteredRows;
            if (filteredRows === undefined) {
                options.filteredRows = filteredRows = rows.filter(filterPredicate);
            }
            rows = filteredRows;
        }

        if (start != undefined) {
            rows = $(rows).slice(start, end);
        }

        if (includeAttached) {
            var list = [];
            rows.each(function (i, row) {
                list.push(row);
                if (row.attachedRows && row.attachedRows.length > 0) {
                    for (var i = 0; i < row.attachedRows.length; i++) {
                        list.push(row.attachedRows[i]);
                    }
                }
            });

            return $(list);
        } else {
            return rows;
        }
    };

    var parserTypes = {
        "int": function (value) {
            var result = parseInt(value);
            return !isNaN(result) ? result : 0;
        },
        "float": function (value) {
            var result = parseFloat(value);
            return !isNaN(result) ? result : 0;
        },
        percent: function (value) {
            return parserTypes["float"](s.replace(/%/g, ''));
        },
        url: function (value) {
            return value.replace(/(https?|ftp|file):\/\//, '');
        },
        currency: function (value) {
            return value.replace(/[^0-9.]/g, '');
        },
        "date": function (value) {
            if ($(value).data("epoch")) {
                return $(value).attr("data-epoch");
            }
            return new Date(value);
        },
        time: function (value) {
            return parserTypes["float"](new Date("2000/01/01 " + value).getTime());
        },
        "time-ms": function (value) {
            return parserTypes["float"](value.replace(/ms/g, ''));
        },
        text: function (value) {
            return value;
        },
        author: function (value) {
            return $(value).find("span").text();
        },
        html: function (value) {
            return $(value).text();
        }
    };

    var updateRowsData = function ($grid) {
        var options = getOptions($grid);

        // Get an updated row selector or use the one in options
        var rowSelector = $grid.attr(options.rowSelectorAttr) || options.rowSelector;
        options.rowSelector = rowSelector;

        var rows = $grid.find(rowSelector);
        if (!options.parentRows) {
            options.parentRows = rows;
        }
        if ($grid.attr('data-update') === 'add') {
            options.parentRows = options.parentRows.add(rows.not('.even').not('.odd'));
            $grid.removeAttr('data-update');
        }
        if ($grid.attr('data-remove')) {
            options.parentRows = options.parentRows.not("li[data-surrogate-id='" + $grid.attr('data-remove') + "']");
            $grid.removeAttr('data-remove');
        }

        if (options.sortingEnabled) {
            $grid.find('> thead > tr > th').each(function (i, th) {
                var $th = $(th);
                var sortType = $th.attr('data-sort-value-type');

                options.parsers[i] = parserTypes[sortType] || parserTypes.text;

                var defaultSortOrder = $th.attr('data-default-sort-order');
                options.defaultSortOrder[i] = defaultSortOrder;
            });

            var resultRows = $([]);
            var lastRow = null;
            rows.each(function (i, row) {
                if ($(row).attr("data-sort-attached-to-above") === "true") {
                    if (lastRow) {
                        lastRow.attachedRows.push(row);
                    }
                    return;
                }
                row.attachedRows = [];
                lastRow = row;
                resultRows = resultRows.add(row);
            });
            rows = resultRows;

            if (options.parsers) {
                rows.each(function (i, row) {
                    row.columns = {};

                    $(row).find('> td').each(function (j, column) {
                        var html = $.trim($(column).attr('data-sort-value') || column.innerHTML.toUpperCase());
                        row.columns[j] = options.parsers[j](html);
                    });

                });
            }
        }

        // Get the parent for the row selector
        options.rowsParent = rows.parent();

        options.rows = rows;
        options.currentPage = 1;

        if (options.sortingEnabled) {
            var defaultSortSlug = $grid.attr('data-default-sort-slug');
            if (defaultSortSlug) {
                var defaultSortOrder = $grid.attr('data-default-sort-order') == 'asc' ? 1 : -1;
                var index = $grid.find('> thead > tr > th').index($grid.find('[data-sort-slug="' + defaultSortSlug + '"]'));
                sort($grid, index, defaultSortOrder);
            }
        }
    };

    var handleScroll = function (pagerElement, options) {
        var pager = $(pagerElement).parent();

        if (pager.parent().hasClass('listing-footer')) {
            $(window).scrollTo(options.container, 500, { 'offset': -50 });
        }
    };

    var goToPage = function (e, $grid, pageNum) {
        e.preventDefault();

        var options = getOptions($grid);

        if (options.currentPage == pageNum)
            return;

        handleScroll(this, options);

        options.currentPage = pageNum;
        updateGrid($grid);
    };

    var onFirst = function (e) {
        e.preventDefault();

        var $grid = $(this).data(cacheKey);
        var options = getOptions($grid);

        handleScroll(this, options);

        if (options.currentPage != 1) {
            options.currentPage = 1;
            updateGrid($grid);
        }
    };

    var onNext = function (e) {
        e.preventDefault();

        var $grid = $(this).data(cacheKey);
        var options = getOptions($grid);

        handleScroll(this, options);

        if ((options.currentPage + 1) > options.pageCount) {
            if (options.enableCircularPaging == true) {
                options.currentPage = 1;
                updateGrid($grid);
            }
        } else {
            options.currentPage = options.currentPage + 1;
            updateGrid($grid);
        }
    };

    var onPrevious = function (e) {
        e.preventDefault();

        var $grid = $(this).data(cacheKey);
        var options = getOptions($grid);

        handleScroll(this, options);

        if ((options.currentPage - 1) <= 0) {
            if (options.enableCircularPaging == true) {
                options.currentPage = options.pageCount;
                updateGrid($grid);
            }
        } else {
            options.currentPage = options.currentPage - 1;
            updateGrid($grid);
        }
    };

    var onLast = function (e) {
        e.preventDefault();

        var $grid = $(this).data(cacheKey);
        var options = getOptions($grid);

        handleScroll(this, options);

        if (options.currentPage != options.pageCount) {
            options.currentPage = options.pageCount;
            updateGrid($grid);
        }
    };

    var getPageCount = function ($grid) {
        var options = getOptions($grid);
        var rowCount = getRows($grid, undefined, undefined, true).length;

        // Determine page count by dividing row count by size of pages and set it in the options
        var pageCount = Math.ceil(rowCount / options.pageSize);
        options.pageCount = pageCount;

        return pageCount;
    };

    var getPageSize = function ($grid) {
        var options = getOptions($grid);

        var pageSizeAttr = options.pageSizeAttr;
        var pageSizeString = $grid.attr(pageSizeAttr);
        var pageSize = parseInt(pageSizeString) || options.pageSize || 25;

        if (options.pageSize != pageSize) {
            options.pageSize = pageSize;
        }

        return pageSize;
    };

    var getVisibleRange = function ($grid) {
        var options = getOptions($grid);

        // Get the start index and end index of visible rows
        var startIndex = (options.currentPage - 1) * options.pageSize;
        var endIndex = Math.floor(startIndex + options.pageSize, options.rowCount);

        return { 'start': startIndex, 'end': endIndex };
    };

    var emptyGrid = function ($grid) {
        var options = getOptions($grid);
        $grid.find(options.rowSelector).detach();
    };

    var appendPagerElement = function ($pager, $grid, pageNum, textOverride) {
        var options = getOptions($grid);

        if (!textOverride)
            textOverride = pageNum;

        var linkContainer = $('<li/>').addClass('b-pagination-item');
        var link = $('<a/>').addClass('b-pagination-item').text(textOverride).attr('data-pagenum', pageNum).data(cacheKey, $grid).click(function (e) { goToPage(e, $(this).data(cacheKey), parseInt($(this).attr('data-pagenum'))) });

        if (pageNum == options.currentPage)
            link.addClass('active').addClass('s-active');

        linkContainer.append(link);
        $pager.append(linkContainer);
    }

    var drawPager = function ($pager, $grid) {
        var options = getOptions($grid);
        $pager.find('li').remove();
        var dots = "<li>...</li>";

        /* If we are not at the first page create a "prev" textual link. */
        if (options.currentPage > 1)
            appendPagerElement($pager, $grid, options.currentPage - 1, 'Prev');

        if (options.pageCount <= options.maxNumOfPageNumbers) {
            /* We have space to display all the page numbers */
            for (var i = 1; i <= options.pageCount; ++i)
                appendPagerElement($pager, $grid, i);
        }
        else if (options.currentPage < (options.maxNumOfPageNumbers - 1)) {
            /* We will display from 1 to X at the beginning, then dots, then the last page only */
            for (var i = 1; i < options.maxNumOfPageNumbers; ++i)
                appendPagerElement($pager, $grid, i);

            $pager.append(dots);
            appendPagerElement($pager, $grid, options.pageCount);
        }
        else if (options.currentPage > (options.pageCount - options.maxNumOfPageNumbers + 1)) {
            /* We will display only the first page, then dots, then from X to the end. */
            appendPagerElement($pager, $grid, 1);
            $pager.append(dots);

            for (var i = options.pageCount - options.maxNumOfPageNumbers + 1; i <= options.pageCount; ++i)
                appendPagerElement($pager, $grid, i);
        }
        else {
            /* We are in the middle */
            appendPagerElement($pager, $grid, 1);
            $pager.append(dots);

            var range = Math.ceil(options.maxNumOfPageNumbers / 2.0) - 1;
            for (var i = options.currentPage - range; i <= options.currentPage + range; ++i)
                appendPagerElement($pager, $grid, i);

            $pager.append(dots);
            appendPagerElement($pager, $grid, options.pageCount);
        }

        /* If we are not at the last page create a "next" textual link. */
        if (options.currentPage < options.pageCount)
            appendPagerElement($pager, $grid, options.currentPage + 1, 'Next');

        $pager.show();
    };

    var redrawGrid = function ($grid) {
        var options = getOptions($grid);

        var visibleRange = getVisibleRange($grid);

        emptyGrid($grid);

        var rows = getRows($grid, visibleRange.start, visibleRange.end, true);

        var $rowParent = $(options.rowsParent).append(rows);
        $rowParent.find('> :odd').not('.odd').addClass('odd').removeClass('even');
        $rowParent.find('> :even').not('.even').addClass('even').removeClass('odd');

        if (options.pagingEnabled) {
            options.pagerElements.each(function () {
                var $pager = $(this);

                if (options.pageCount <= 1) {
                    $pager.hide();
                } else {
                    drawPager($pager, $grid);
                }

                var $pageNumbers = $(this).find(options.pagerPageNumbersSelector);
                if ($pageNumbers) {
                    $pageNumbers.find('li').remove();

                    for (var pageNumber = 1; pageNumber <= options.pageCount; ++pageNumber) {
                        var pageLink = $('<li/>').addClass('b-pagination-item');
                        var pageLinkText = $('<span/>').text(pageNumber);

                        pageLink.append(pageLinkText);
                        $pageNumbers.append(pageLink);
                    }
                }
            });
        }
    };

    var getSortOrder = function ($grid, e, defaultSortOrder) {
        var options = getOptions($grid);
        var $e = $(e);
        var order;
        var useDefault = !$e.hasClass(options.sortAscClass) && !$e.hasClass(options.sortDescClass);
        if (useDefault) {
            order = (defaultSortOrder == "desc" ? -1 : 1);
        }
        else if ($e.hasClass(options.sortDescClass)) {
            order = 1;
        }
        else {
            order = -1;
        }

        return order;
    };

    var getSortLink = function ($grid, index) {
        var $sortLinks = $grid.find(' > thead > tr > th a');
        if ($sortLinks.length == 0) $sortLinks = $grid.find(' > thead > tr > th');

        if (index != undefined) {
            return $sortLinks.eq(index);
        }

        return $sortLinks;
    };

    var toggleSortOrder = function ($grid, i, order) {
        var options = getOptions($grid);

        var $e = getSortLink($grid, i);

        if (order == -1) {
            $e.removeClass(options.sortAscClass).addClass(options.sortDescClass);
        } else {
            $e.removeClass(options.sortDescClass).addClass(options.sortAscClass);
        }

        $e.addClass('selected');

        getSortLink($grid).not($e).removeClass(options.sortAscClass + ' .selected ' + options.sortDescClass);
    };

    var sort = function ($grid, i, order) {
        var options = getOptions($grid);
        var rows = getRows($grid, undefined, undefined, false, false).get();

        rows.sort(function (a, b) {
            var keyA = a.columns[i];
            var keyB = b.columns[i];

            // if the types don't match, check their modulus and 'discard' them to the bottom or top of the stack
            if ($.type(keyA) !== $.type(keyB)) {
                if (keyA % 1 !== 0) return -1 * order;
                if (keyB % 1 !== 0) return 1 * order;
            }

            if (keyA < keyB) return -1 * order;
            if (keyA > keyB) return 1 * order;

            return 0;
        });

        options.parentRows = $(rows);

        toggleSortOrder($grid, i, order);

        updateGrid($grid);
    };

    var updateGrid = function ($grid) {
        getPageSize($grid);
        getPageCount($grid);

        redrawGrid($grid);

        var options = getOptions($grid);
        if (options.enableCircularPaging == false) {
            var $pager = options.pagerElements;
            if (options.currentPage != 1 && options.currentPage != options.pageCount) {
                setFirstPreviousVisibility($pager, options, true);
                setLastNextVisibility($pager, options, true);
            }
            else if (options.currentPage == 1) {
                setFirstPreviousVisibility($pager, options, false);
                setLastNextVisibility($pager, options, true);
            }
            else if (options.currentPage == options.pageCount) {
                setFirstPreviousVisibility($pager, options, true);
                setLastNextVisibility($pager, options, false);
            }
        }
        Cobalt.triggerHtmlInsert($grid);
    };

    var setFirstPreviousVisibility = function ($pager, options, bool) {
        if (bool) {
            if (options.showFirstSelector) {
                setVisible($pager.find(options.pagerFirstSelector));
            }
            setVisible($pager.find(options.pagerPreviousSelector));
        }
        else {
            if (options.showFirstSelector) {
                setHidden($pager.find(options.pagerFirstSelector));
            }
            setHidden($pager.find(options.pagerPreviousSelector));
        }
    }

    var setLastNextVisibility = function ($pager, options, bool) {
        if (bool) {
            if (options.showLastSelector) {
                setVisible($pager.find(options.pagerLastSelector));
            }
            setVisible($pager.find(options.pagerNextSelector));
        }
        else {
            if (options.showLastSelector) {
                setHidden($pager.find(options.pagerLastSelector));
            }
            setHidden($pager.find(options.pagerNextSelector));
        }
    }

    var setVisible = function (element) {
        element.removeClass("pager-hidden");
        element.addClass("pager-visible");
    }

    var setHidden = function (element) {
        element.removeClass("pager-visible");
        element.addClass("pager-hidden");
    }

    var initializeGrid = function ($grid, options) {
        if (options !== undefined) {
            $grid.data(cacheKey, options);
        } else {
            // TODO : Error!
            return;
        }

        if (options.pagingEnabled) {
            var pagerElements = options.pagerElements;

            if (pagerElements === undefined) {
                // Create default pagers...
            }

            pagerElements.each(function () {
                var $pager = $(this);
                $pager.find(options.pagerNextSelector).unbind("click");
                $pager.find(options.pagerPreviousSelector).unbind("click");
                $pager.find(options.pagerFirstSelector).click(onFirst).data(cacheKey, $grid).addClass("pager-hidden");
                $pager.find(options.pagerNextSelector).click(onNext).data(cacheKey, $grid);
                $pager.find(options.pagerPreviousSelector).click(onPrevious).data(cacheKey, $grid).addClass("pager-hidden");
                $pager.find(options.pagerLastSelector).click(onLast).data(cacheKey, $grid)

                if (!$pager.find(options.pagerFirstSelector).is(":visible")) {
                    options.showFirstSelector = false;
                }
                if (!$pager.find(options.pagerLastSelector).is(":visible")) {
                    options.showLastSelector = false;
                }
            });
        }

        updateRowsData($grid);
        updateGrid($grid);

        if (options.sortingEnabled) {
            var sortLinks = getSortLink($grid);

            sortLinks.each(function (i, e) {
                var $sortLink = $(this);

                $sortLink.click(function (event) {
                    event.preventDefault();

                    var $sortLink = $(this);

                    var grid = $sortLink.data(cacheKey);
                    var defaultSortOrder = options.defaultSortOrder[i];
                    var sortOrder = getSortOrder(grid, $sortLink, defaultSortOrder);

                    sort(grid, i, sortOrder);
                }).data(cacheKey, $grid);
            });
        }
    }

    $.fn.grid = function (options) {
        // Iterate over each jQuery DOM element
        return this.each(function () {

            var $grid = $(this);

            // Merge the passed in options with the defaults
            var opts = $.extend({}, defaultOptions, options);

            opts.container = $grid.parents('.listing-container:eq(0)');

            // If no pager elements were specified lets look for some defaults
            if (opts.pagerElements === undefined) {
                opts.pagerElements = opts.container.find('> .listing-header').add(opts.container.find('> .listing-footer')).find('.j-tablesorter-pager');
            }
            // Paging only enabled when container is set properly
            if (opts.pagerElements === undefined || opts.pagerElements.length < 1) {
                opts.pagingEnabled = false;
            } else {
                opts.pagingEnabled = true;
            }

            // Sorting only enabled for tables
            if (!$grid.is('table') || $grid.find('> thead > tr > th').length < 1) opts.sortingEnabled = false;

            var data = getOptions($grid);
            // Grid hasn't been initialized, do so
            if (data === undefined) {
                initializeGrid($grid, opts);
            } else {
                updateRowsData($grid);
                updateGrid($grid, opts);
            }

            return this;
        });
    };

    $.fn.gridFilter = function (predicate) {
        return this.each(function () {
            var $grid = $(this);

            var options = getOptions($grid);
            if (options == undefined || options.filterPredicate == predicate) {
                return;
            }

            options.filterPredicate = predicate;
            delete options.filteredRows;

            var pageCount = getPageCount($grid);
            if (pageCount < options.currentPage) {
                options.currentPage = pageCount;
            }
            if (options.currentPage <= 0) {
                options.currentPage = 1;
            }
            redrawGrid($grid);
        });
    };
})(jQuery);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.JQuery.Grid.js